import { PermissionRule, User } from '../types/common';

export const can = (
  user: Pick<User, 'role' | 'permissions'> | null | undefined,
  resource: string,
  action: string,
): boolean => {
  if (!user) return false;
  const rules = user.permissions;
  if (!rules) return false;

  const normalizedResource = resource.toLowerCase();
  const normalizedAction = action.toLowerCase();
  return rules.some(
    (rule: PermissionRule) =>
      (rule.resource.toLowerCase() === 'all' &&
        rule.action.toLowerCase() === 'manage') ||
      (rule.resource.toLowerCase() === normalizedResource &&
        rule.action.toLowerCase() === normalizedAction),
  );
};

export const canAny = (
  user: Pick<User, 'role' | 'permissions'> | null | undefined,
  checks: Array<[resource: string, action: string]>,
): boolean => checks.some(([resource, action]) => can(user, resource, action));
